import { booleanAttribute, Directive, inject, input, TemplateRef } from '@angular/core';
import { ActionTemplateContext, DefaultActionId } from './his-tree-action-buttons.model';

/**
 * Place on an `<ng-template>` inside `<his-tree-action-buttons>` to override
 * the rendering of a specific action by its ID.
 *
 * ```html
 * <his-tree-action-buttons [rowNode]="rowNode" [config]="cfg">
 *   <ng-template hisTreeActionTemplate="edit" let-action>
 *     <my-button [label]="action.title | hisUi" (click)="onEdit()" />
 *   </ng-template>
 * </his-tree-action-buttons>
 * ```
 */
@Directive( {
    selector: 'ng-template[hisTreeActionTemplate]',
    standalone: true,
} )
export class HisTreeActionTemplateDirective {
    /** ID of the action whose default rendering this template replaces */
    readonly hisTreeActionTemplate = input.required<DefaultActionId | ( string & {} )>();
    readonly replaceEntireTemplate = input( false, { transform: booleanAttribute } );
    public readonly templateRef = inject<TemplateRef<ActionTemplateContext>>( TemplateRef );

    /** Type guard for the template context to provide compiler support on defined variables */
    static ngTemplateContextGuard(
        _dir: HisTreeActionTemplateDirective,
        ctx: unknown,
    ): ctx is ActionTemplateContext {
        return true;
    }
}